import React, {  useState } from 'react';
import { Form, Row, Col, Modal } from 'antd';
import {
  LayoutWithoutAuth,
  Input,
  Button,
  Typography,
  Countdown,
} from 'components';
import { useHistory, useParams } from 'react-router-dom';
import './forgot-password.less';
import * as loginService from 'services/login.service';
import { customMessages } from 'utils';
import { useDispatch } from 'react-redux';


const ApplySmsCodePage = () => {
  let history = useHistory();
  let { gsmNumber } = useParams();
  const dispatch = useDispatch();

  const [otpCounterStarted, setOtpCounterStarted] = useState(true);

  function checkOtp(values) {
    let data = values;
    data.msisdn = gsmNumber;
    loginService
      .validateOtp(values)
      .then((res) => {
        
        dispatch({
          type: 'LOGIN',
          payload: res,
        });
        history.push(`/ForgotPasswordNewPasswordPage/`+ gsmNumber);
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
  }

 function submitForm(values) {
    if (otpCounterStarted)
    {
      checkOtp(values);
    }
    else{
      loginService.sendForgetOtp({msisdn:gsmNumber}).then((result) => {
        setOtpCounterStarted(true);
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
    }
 }

  return (
    <LayoutWithoutAuth className="forgot-password">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="forgot-password-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Şifremi Unuttum</h1>
            </Col>
            <Col span={24} className="flex-center-center">
              <p className="info-text--big">
                <strong>{gsmNumber}</strong> numaralı telefonunuza gelen doğruluma kodunu giriniz.
              </p>
            </Col>
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-m"
            >
              {<Countdown changedCounter={setOtpCounterStarted} startCounter={otpCounterStarted} />}
            </Col>
            <Form
              style={{ width: '100%' }}
              name="forgotPassword"
              onFinish={(values) => {
                submitForm(values);               
              }}
              onFinishFailed={(event) =>
                console.log('onFinishFailed applySmsCode form ==> ', event)
              }
            >
              <Form.Item name="otp">
                <Input maxLength={6}
                  autoComplete="off"
                  label="SMS Kodu" 
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={30}>
                    <Col span={12}>
                      <Button
                        type="ghost"
                        onClick={() => history.push('/ForgotPasswordPage')}
                      >
                        Önceki Adım
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button type="primary" htmlType="submit" shape="round">
                      {otpCounterStarted ? 'Doğrula':'Tekrar Gönder'} 
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default ApplySmsCodePage;
